export default __webpack_public_path__ + "static/1299-59f674f81ae0a3228cddff97ce03199d.gif";